import React, { useContext } from 'react';
import ReactDOM from 'react-dom';

//component
import UserWorkspacesTab from  '@/components/page/OrgSettings/Users/Workspaces/UserWorkspacesTab';

//context
import { OrgSettingsContext } from '@/context/OrgSettings';
import { OrgSettingsUsersContext } from '@/context/OrgSettingsUsersContext';



const UserWorkspacesTabPortal = () => {    
    const { setOrgId } = useContext(OrgSettingsContext);
    const { setUserId } = useContext(OrgSettingsUsersContext);

    const targetContainer = document.getElementById('react-workspace-table-container');
    
    if(!targetContainer) {
        return null;
    } else {
        setOrgId(targetContainer.getAttribute('data-org-id'));
        setUserId(targetContainer.getAttribute('data-user-id'));
    }

    return ReactDOM.createPortal(
      <UserWorkspacesTab />, targetContainer
    );
}


export default UserWorkspacesTabPortal;